<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Invoice Details</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>

    <v-card-text style="max-height: 85%">
      <InvoiceAccountsDetails :details="details" />
      <br />      

      <InvoiceReceives
        :payments="details ? details.receives : []"
        @add="onAddReceive"
        @delete="onReceiveDelete"
      />
      <br />

      <InvoiceExpenses
        :payments="details ? details.payments : []"
        @add="onAddPayment"
        @delete="onPaymentDelete"
      />
      <br />

      <InvoiceOtherDetails type="client" :item="details ? details.client : {}" title="Client Details" />
      <br />

      <InvoiceOtherDetails type="company" :item="details ? details.company : {}" title="Company Details" />
      <br />

      <InvoiceOtherDetails type="coordinator" :item="details ? details.coordinator : {}" title="Coordinator Details" />
      <br />
      <!--<MdsirFileWidget :ofID="item.id" ofName="projects" /> -->
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Close</v-btn>
    </v-card-actions>

    <v-dialog v-model="isPaymentModal" scrollable persistent max-width="600px">
      <InvoicePaymentReceiveForm
        :invoice="item"
        :accountHeadsTV="accountHeadsTV"
        :type="selectedPaymentType"
        @cancelled="isPaymentModal = false"
        @added="onPaymentAdded"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";
import { getTV, removeEmptyProps } from "../../mdsir/MdsirUtils";

// import MdsirFileWidget from "../file-widget/MdsirFileWidget";
// import ProjectPaymentReceiveForm from "./ProjectPaymentReceiveForm";
// import ProjectPayments from "./ProjectPayments";
// import ProjectAgentDetails from "./ProjectAgentDetails";
// import ProjectCandidateDetails from "./ProjectCandidateDetails";
import InvoiceAccountsDetails from "./InvoiceAccountsDetails";
import InvoiceOtherDetails from "./InvoiceOtherDetails";
import InvoiceExpenses from "./InvoiceExpenses";
import InvoiceReceives from "./InvoiceReceives";
import InvoicePaymentReceiveForm from "./InvoicePaymentReceiveForm";

export default {
  components: {
    // MdsirFileWidget,
    // ProjectPaymentReceiveForm,
    // ProjectPayments,
    // ProjectAgentDetails,
    // ProjectCandidateDetails,
    InvoiceAccountsDetails,
    InvoiceOtherDetails,
    InvoiceExpenses,
    InvoiceReceives,
    InvoicePaymentReceiveForm
  },
  props: ["item", "details"],
  data() {
    return {
      // actionButtonClicked: false,
      // valid: true,
      // newItem: {
      //   name: "",
      //   mobile: "",
      //   email: "",
      //   notes: "",
      //   address: "",
      // },
      // categories: []
      // agentProps: [
      //   { title: "Name", key: "name" },
      //   { title: "Mobile", key: "mobile" },
      //   { title: "Email", key: "email" },
      //   { title: "Address", key: "address" },
      //   { title: "Notes", key: "notes" },
      // ],

      relatedFiles: [],
      isPaymentModal: false,
      selectedPaymentType: "",
      accountHeads: [],
    };
  },
  computed: {
    accountHeadsTV() {
      return getTV(this.accountHeads, { textField: "title", valueField: "id" });
    },
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onPaymentAdded(addedData) {
      this.$emit("paymentAdded", addedData);
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    onAddPayment() {
      this.isPaymentModal = true;
      this.selectedPaymentType = "payment";
      this.get("/account_heads").then((response) => {
        this.accountHeads = response.data.data;
      });
    },
    async onPaymentDelete(payment) {
      const res = await this.$http.delete(`/expense/${payment.id}`);
      this.snackbarShow(res.data);
      if (res.data.success) {
        this.$emit("reload");
      }
    },

    onAddReceive() {
      this.isPaymentModal = true;
      this.selectedPaymentType = "receive";
    },
    async onReceiveDelete(payment) {
      const res = await this.$http.delete(`/receive/${payment.id}`);
      this.snackbarShow(res.data);
      if (res.data.success) {
        this.$emit("reload");
      }
    },
  },
  mounted() {
    // this.loadRelatedFiles();
  },

  beforeDestroy() {},

  created() {
    this.GENDERS = GENDERS;
  },
};
</script>

<style>
.table-r {
  border-collapse: collapse;
  width: 100%;
  margin: 10px 0 10px 0;
}

.table-r td,
.table-r th {
  border-bottom: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.table-r tr:nth-child(1) {
  background-color: #dddddd;
}
</style>
